import { Phone, Calendar, Car } from "lucide-react";

const steps = [
  {
    number: "1",
    icon: Phone,
    title: "Call or Text",
    description: "Contact us at 971-344-5446 or fill out our online form with your transportation needs.",
  },
  {
    number: "2",
    icon: Calendar,
    title: "Schedule Your Ride",
    description: "We'll confirm your appointment time, pickup location, and destination details.",
  },
  {
    number: "3",
    icon: Car,
    title: "Sit Back & Relax",
    description: "Our professional driver will arrive on time and transport you safely to your destination.",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-14 sm:py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-foreground mb-3 sm:mb-4">
            How It Works
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Simple, straightforward process to get you where you need to go
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-primary flex items-center justify-center mb-4 sm:mb-6 shadow-lg">
                  <step.icon className="h-7 w-7 sm:h-9 sm:w-9 text-primary-foreground" />
                  <div className="absolute -top-2 -right-2 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-accent text-accent-foreground flex items-center justify-center text-xs sm:text-sm font-bold shadow">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2 sm:mb-3">
                  {step.title}
                </h3>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-border" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
